import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from './api';

// Spiegelung von src/server/session.ts:sessionRoleSchema. 'reinigung' ist in
// DB-Tabelle `roles` und in src/events/schemas.ts registriert, aber im
// Backend-Session-Schema absichtlich noch nicht freigeschaltet (CEO-Variante-B
// 2026-05-05, F-401). Solange der Phase-5-Auftragstyp-Filter nicht live ist,
// versendet das Backend diesen Wert nie — also auch hier nicht typisieren,
// damit der Vertrag synchron bleibt (F-804).
export interface SessionUser {
  userId: string;
  email: string;
  role: 'admin' | 'buero' | 'aussendienst' | 'pending';
}

interface MeResponse {
  user: SessionUser;
}

export function useSession() {
  return useQuery<SessionUser | null>({
    queryKey: ['session'],
    queryFn: async () => {
      try {
        const res = await api<MeResponse>('/me');
        return res.user;
      } catch (err) {
        if (err instanceof ApiError && (err.status === 401 || err.status === 404)) return null;
        throw err;
      }
    },
    retry: false,
    staleTime: 30_000,
  });
}

export async function devLogin(email: string): Promise<void> {
  await api('/auth/dev-login', { method: 'POST', body: { email } });
}

export async function logout(): Promise<void> {
  await api('/auth/logout', { method: 'POST' });
}
